'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropTypes = exports.openingShape = exports.momentShape = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    componentName = componentName || 'ANONYMOUS';
    propFullName = propFullName || propName;
    if (props[propName] == null) {
      if (isRequired) {
        throw new Error('Required ' + location + ' `' + propFullName + '` was not specified in `' + componentName + '`');
      }
      return null;
    }
    return validate(props, propName, componentName, location);
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function checkMomentType(props, propName, componentName, location, propFullName) {
  propFullName = propFullName || propName;
  var value = props[propName];
  if (value != null && !_momentTimezone2.default.isMoment(value)) {
    throw new Error('Invalid ' + location + ' `' + propFullName + '` supplied to `' + componentName + '`, expected moment object.');
  }
}

var momentShape = exports.momentShape = createChainableTypeChecker(checkMomentType);

var openingShape = exports.openingShape = _propTypes2.default.shape({
  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
  uri: _propTypes2.default.string,
  time: momentShape.isRequired,
  isSelected: _propTypes2.default.bool,
  isOld: _propTypes2.default.bool
});

// For backwards compatibility
var PropTypes = exports.PropTypes = {
  moment: momentShape
};